<template>
    <div>
        <div class="cloudTrail-title">
            <div>{{ $t('CloudTrailSecurity.title') }}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['logs:cloudTrail:add_alert_rule']">{{ $t('CloudTrailSecurity.addCloudTrailSecurityAlertRule') }}</Button>
                <add-or-update-cloud-trail-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-cloud-trail-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.common.alertRule')">
                    <div class="cloudTrail-top">
                        <cloud-trail-warning-search></cloud-trail-warning-search>
                    </div>
                    <table-cloud-trail-warning></table-cloud-trail-warning>
                </TabPane>
                <TabPane :label="$t('CloudTrailSecurity.title')">
                    <div class="cloudTrail-top">
                        <cloud-trail-list-search></cloud-trail-list-search>
                    </div>
                    <table-cloud-trail-list></table-cloud-trail-list>
                </TabPane>
            </Tabs>
        </template>
        
    </div>
</template>

<script>
    import CloudTrailListSearch from '../cloudTrail/cloudTrail_list/CloudTrailListSearch'
    import TableCloudTrailList from '../cloudTrail/cloudTrail_list/TableCloudTrailList'
    import CloudTrailWarningSearch from '../cloudTrail/cloudTrail_monitor/CloudTrailWarningSearch'
    import TableCloudTrailWarning from '../cloudTrail/cloudTrail_monitor/TableCloudTrailWarning'
    import AddOrUpdateCloudTrailWarning from '../cloudTrail/cloudTrail_monitor/AddOrUpdateCloudTrailWarning'

    export default {
        name: 'CloudTrail',
        components: {
            CloudTrailListSearch,
            TableCloudTrailList,
            CloudTrailWarningSearch,
            TableCloudTrailWarning,
            AddOrUpdateCloudTrailWarning
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
         methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .cloudTrail-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .cloudTrail-title>div:nth-child(1)
    {
        float:left;
    }
    .cloudTrail-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .cloudTrail-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/CloudTrail.vue